import { render } from "./ParticlesDust.vue?vue&type=template&id=5268a76b&scoped=true"
import script from "./ParticlesDust.vue?vue&type=script&lang=js"
export * from "./ParticlesDust.vue?vue&type=script&lang=js"

import "./ParticlesDust.vue?vue&type=style&index=0&id=5268a76b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5268a76b"]])

export default __exports__